import { Inject, Injectable } from '@angular/core';
import { DataService } from '../http/dataService';
import { ENV, IEnvironment } from 'env/config';

import { Service } from '../entity';
import { CentralApis } from '../interfaces/internal';
import { Repository } from './repository';
import { InsightsResponse } from '../models';
import { Observable } from 'rxjs';

@Service({
  api: 'insight',
  model: InsightsResponse,
})
@Injectable({ providedIn: 'root' })
export class InsightsService extends Repository<InsightsResponse> {
  insightsBaseUrl: string;

  constructor(@Inject(ENV) env: IEnvironment, dataService: DataService) {
    super({
      client: dataService,
      url: (env.api.backend.central.endpoint as CentralApis).territory,
    });

    this.insightsBaseUrl = this.url;
  }

  getInsight(
    id: string,
    feature: string,
    data?: any
  ): Observable<InsightsResponse> {
    if (data) {
      return super.post(data, null, {
        feature,
        id,
      });
    } else {
      return super.getOne({
        feature,
        id,
      });
    }
  }
}
